import http, { AUTH_ROUTES } from '../../../services/api';

export const getChatMessages = async (issueID, userId, setLoading, setChatMessages) => {
  //   setLoading(true);
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_CHAT_MESSAGE(issueID, userId));
    console.log('chatssss', data);
    setChatMessages(data?.issueChats);
  } catch (e) {
    console.log('e.response', e.response);
  } finally {
    setLoading(false);
  }
};

export const sendChatMessage = async (payload, setBtnLoading, setRefresh, setTypedMessage) => {
  setBtnLoading(true);
  try {
    const { data } = await http.post(AUTH_ROUTES.SEND_CHAT_MESSAGE, payload);

    console.log('sendChatMessage', data);
    setRefresh({});
  } catch (e) {
    console.log('send chat', e.response);
  } finally {
    setBtnLoading(false);
  }
};

export const getEstateInfo = async (userId, setLoading, setEstateInfo) => {
  setLoading(true);
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_ESTATE_INFO(userId));

    setEstateInfo(data);
    setLoading(false);
  } catch (error) {
    console.log(error.response);
    setLoading(false);
  }
};
